import React from 'react';
import { gql } from '@apollo/client';
import IdInput from 'components/Filter/IdInput';
import { BooleanField, Datagrid, BooleanInput, DateInput } from 'react-admin';
import List from 'components/List';
import PositionInput from 'components/PositionInput';
import LinkField from 'components/LinkField';
import DateTimeField from 'components/DateTimeField';
import MarketInput from 'components/MarketInput';
import LocationTypeInput from 'components/LocationTypeInput';
import { getSettingsQuery } from '../utils/getSettingsQuery';

const MarketLocationTypePositionRateSettingListFilters = [
  <IdInput />,
  <MarketInput label="Market" source="market_id" alwaysOn resettable />,
  <LocationTypeInput label="Location Type" source="location_type_id" alwaysOn resettable />,
  <PositionInput emptyText="All" alwaysOn />,
  <BooleanInput alwaysOn source="active" />,
  <DateInput alwaysOn label="Updated after" source="search.updated_at_from" />,
];

const MarketLocationTypePositionRateSettingList = () => {
  return (
    <List filters={MarketLocationTypePositionRateSettingListFilters} exporter={false}>
      <Datagrid bulkActionButtons={false}>
        <LinkField label="ID" source="id" />
        <LinkField label="Market" source="market.display_name" sortBy="market_name" />
        <LinkField label="Location Type" source="location_type.label" sortBy="location_type_name" />
        <LinkField label="Position" source="position.display_name" sortBy="position_name" />
        <LinkField label="Specialty" source="specialty.label" sortBy="specialty_name" />
        <BooleanField source="active" />
        <DateTimeField
          format="MM/dd/yyyy HH:mm"
          source="updated_at"
          timeZone="America/Los_Angeles"
        />
      </Datagrid>
    </List>
  );
};

MarketLocationTypePositionRateSettingList.query = gql`
  query marketLocationTypePositionRateSettings(
    $input: MarketLocationTypePositionRateSettingQueryInput
  ) {
    _marketLocationTypePositionRateSettingsMeta(input: $input) {
      count
    }
    marketLocationTypePositionRateSettings(input: $input) {
      id
      active
      position {
        id
        display_name
      }
      position_id
      location_type {
        id
        label
      }
      location_type_id
      market {
        id
        display_name
      }
      market_id
      market_position_rate_setting_id
      market_location_type_position_rate_setting_id
      state_position_rate_setting_id
      state_location_type_position_rate_setting_id
      state_location_type_position_rate_setting_active
      state_position_rate_setting_active
      market_location_type_position_rate_setting_active
      ${getSettingsQuery(true)}
      specialty {
        id
        label
      }
      with_markup_settings {
        ten99 {
          charge_rate_cents
        }
        w2 {
          local {
            charge_rate_cents
          }
          travel {
            charge_rate_cents
          }
        }
      }
      ${getSettingsQuery(true, 'active_non_markup_settings')}
      blended_settings_charge_rate
      non_blended_settings_charge_rate
      specialty_id
      updated_at
    }
  }
`;

export default MarketLocationTypePositionRateSettingList;
